const nodeListToArray = (nodeList, filter) => {
  var items = []

  for (var i = 0; i !== nodeList.length; ++i) {
    if (!filter || nodeList[i].matches(filter)) {
      items.push(nodeList[i])
    }
  }

  return items
}

export default nodeListToArray